export interface DividerProps {
  className?: string
}

export const Divider = ({ className = '' }: DividerProps) => {
  return <hr className={`border-alto mt-4 mb-7 ${className}`} />
}
